import { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blog-posts";

const categories = [
  "Todos",
  "Control de Demanda",
  "Análisis Energético",
  "Industria & Operaciones",
  "Eficiencia Energética",
  "Sostenibilidad",
  "Casos de Éxito",
];

const Blog = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  const filteredPosts = blogPosts
    .filter((p) =>
      selectedCategory === "Todos" ? true : p.category === selectedCategory
    )
    .filter((p) =>
      p.title.toLowerCase().includes(search.toLowerCase()) ||
      p.excerpt.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) =>
      sortOrder === "desc"
        ? new Date(b.date).getTime() - new Date(a.date).getTime()
        : new Date(a.date).getTime() - new Date(b.date).getTime()
    );

  return (
    <section className="min-h-screen bg-[#f3f4f6] pb-24">

      {/* HERO */}
      <div className="relative h-[460px] bg-black overflow-hidden">

        {/* Imagen panorámica */}
        <div className="absolute inset-0">
          <img
            src="/lovable-uploads/hero-blog.png"
            alt="Hero Blog Sergen"
            className="w-full h-full object-cover object-[center_75%]"
          />

          {/* Degradado */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70" />
        </div>

        {/* Texto del HERO */}
        <div className="relative z-10 max-w-5xl mx-auto px-6 pt-32 text-white">
          <h1 className="text-5xl font-extrabold mb-4 tracking-tight">
            Bienvenido al Blog SERGEN
          </h1>

          <p className="text-lg max-w-3xl mb-6 opacity-90">
            Tendencias, análisis y conocimiento aplicado en eficiencia energética industrial.
          </p>

          <button
            onClick={() => setShowFilters(true)}
            className="inline-block bg-[#E58A1F] px-6 py-3 rounded-xl font-semibold text-white hover:bg-[#cf7a1b] transition"
          >
            Explorar artículos
          </button>
        </div>

        {/* PANEL DE FILTROS */}
        {showFilters && (
          <div
            className="
              absolute
              bottom-[100px]
              left-1/2
              -translate-x-1/2
              z-30
              w-[90%]
              max-w-6xl
            "
          >
            <div
              className="
                bg-white/70
                backdrop-blur-xl
                shadow-2xl
                rounded-3xl
                p-10
                border border-white/60
              "
            >
              {/* HEADER */}
              <div className="flex justify-between items-center mb-10">
                <h3 className="text-2xl font-bold text-gray-800">
                  Filtrar artículos
                </h3>

                <button
                  onClick={() => setShowFilters(false)}
                  className="text-gray-600 hover:text-black text-3xl font-bold"
                >
                  ✕
                </button>
              </div>

              {/* FILTROS */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                {/* BUSCAR */}
                <div className="flex flex-col">
                  <label className="text-sm mb-1 font-semibold text-gray-700">
                    Buscar
                  </label>
                  <input
                    type="text"
                    placeholder="Escribe aquí..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="
                      px-5 py-4
                      rounded-xl
                      border border-gray-300
                      bg-white
                      text-gray-800
                      focus:ring-2 focus:ring-[#E58A1F]
                      focus:border-[#E58A1F]
                    "
                  />
                </div>

                {/* CATEGORÍA */}
                <div className="flex flex-col">
                  <label className="text-sm mb-1 font-semibold text-gray-700">
                    Categoría
                  </label>
                  <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    className="
                      px-5 py-4
                      rounded-xl
                      border border-gray-300
                      bg-white
                      text-gray-800
                      focus:ring-2 focus:ring-[#E58A1F]
                      focus:border-[#E58A1F]
                    "
                  >
                    {categories.map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                </div>

                {/* FECHA */}
                <div className="flex flex-col">
                  <label className="text-sm mb-1 font-semibold text-gray-700">
                    Ordenar por fecha
                  </label>
                  <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                    className="
                      px-5 py-4
                      rounded-xl
                      border border-gray-300
                      bg-white
                      text-gray-800
                      focus:ring-2 focus:ring-[#E58A1F]
                      focus:border-[#E58A1F]
                    "
                  >
                    <option value="desc">Más recientes</option>
                    <option value="asc">Más antiguos</option>
                  </select>
                </div>

              </div>
            </div>
          </div>
        )}
      </div>

      {/* GRID DE ARTÍCULOS */}
      <div className="max-w-7xl mx-auto px-6 mt-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {filteredPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg border hover:shadow-2xl transition"
            >
              <div className="h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              <div className="p-6">
                
                <p className="text-sm font-medium text-[#E58A1F] mb-2">
                  {new Date(post.date).toLocaleDateString("es-ES", {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                  })}
                </p>


                <h2 className="text-2xl font-semibold text-gray-900 group-hover:text-[#E58A1F] transition-colors mb-3">
                  {post.title}
                </h2>

                <p className="text-gray-600 leading-relaxed line-clamp-3">
                  {post.excerpt}
                </p>

                <div className="mt-4 text-sm font-medium group-hover:underline">
                  Leer más →
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Blog;
